// custom-variant-dropdown.js

document.addEventListener('DOMContentLoaded', function () {
    // Fallback for PUB_SUB_EVENTS if not defined (it should be in Dawn)
    if (typeof PUB_SUB_EVENTS === 'undefined') {
      window.PUB_SUB_EVENTS = {
        cartUpdate: 'cart:update',
        quantityUpdate: 'quantity:update',
        variantChange: 'variant:change', // Used to re-sync custom UI
        optionValueSelectionChange: 'option-value:selection-change' // The event product-info.js listens for
      };
      console.warn("PUB_SUB_EVENTS was not defined. Using a fallback. Check script load order if issues persist.");
    }
  
    function initializeCustomDropdown(container) {
      const productInfoElement = container.closest('product-info');
      if (!productInfoElement) {
        console.warn('Custom dropdown container is not within a product-info element:', container);
        return;
      }
  
      const dropdownButton = container.querySelector('[data-custom-dropdown-button]');
      const dropdownList = container.querySelector('[data-custom-dropdown-list]');
      const selectedValueDisplay = container.querySelector('[data-custom-selected-value]');
  
      if (!dropdownButton || !dropdownList || !selectedValueDisplay) {
        console.warn('Custom dropdown interactive elements not found for a container:', container);
        return;
      }
  
      const getSectionId = () => productInfoElement.dataset.originalSection || productInfoElement.dataset.section;
  
      const getHiddenVariantSelectsContainer = () => {
        const sectionId = getSectionId();
        if (!sectionId) return null;
        return document.querySelector(`#variant-selects-${sectionId}`);
      };
  
      const getSelectedOriginalValues = () => {
        const hiddenContainer = getHiddenVariantSelectsContainer();
        if (!hiddenContainer) return [];
  
        const selectedValues = [];
        // Each option (Size, Color, etc.) is usually in its own fieldset or div
        const optionInputs = hiddenContainer.querySelectorAll('.product-form__input select, .product-form__input input[type="radio"]');
  
        // This needs to be smarter to respect option order
        const optionsOrder = [];
        const tempOptionContainers = hiddenContainer.children;
        for(let i=0; i<tempOptionContainers.length; i++) {
          const child = tempOptionContainers[i];
          if ((child.tagName === 'FIELDSET' && child.classList.contains('product-form__input')) ||
              (child.tagName === 'DIV' && child.classList.contains('product-form__input--dropdown'))) {
                const select = child.querySelector('select');
                const checkedRadio = child.querySelector('input[type="radio"]:checked');
                if (select) {
                  optionsOrder.push(select.value);
                } else if (checkedRadio) {
                  optionsOrder.push(checkedRadio.value);
                } else if (child.querySelector('input[type="radio"]')) {
                  optionsOrder.push(undefined); // Option exists but nothing selected
                }
          }
        }
        return optionsOrder;
      };
  
      const updateCustomDropdownDisplay = () => {
        const currentSelectedOriginalValues = getSelectedOriginalValues();
        const optionIndexForThisDropdown = parseInt(dropdownList.querySelector('.custom-variant-dropdown__item')?.dataset.optionIndex || '0', 10);
        let valueToDisplay = currentSelectedOriginalValues[optionIndexForThisDropdown];
  
        let selectedItemInCustomList = null;
  
        if (valueToDisplay !== undefined) {
          selectedItemInCustomList = dropdownList.querySelector(`.custom-variant-dropdown__item[data-value="${CSS.escape(valueToDisplay)}"]`);
          if (selectedItemInCustomList && selectedItemInCustomList.classList.contains('disabled')) {
            valueToDisplay = undefined; // Selected variant is disabled, treat as no selection for display
            selectedItemInCustomList = null;
          }
        }
  
        if (valueToDisplay === undefined) { // If no valid selection or selected is disabled
          const firstAvailableItem = dropdownList.querySelector('.custom-variant-dropdown__item:not(.disabled)');
          if (firstAvailableItem) {
            valueToDisplay = firstAvailableItem.dataset.value;
            selectedItemInCustomList = firstAvailableItem;
          } else {
            selectedValueDisplay.textContent = container.dataset.noOptionsText || 'N/A'; // Set a default "no options" text
          }
        }
  
        if (valueToDisplay !== undefined && selectedValueDisplay) {
           selectedValueDisplay.textContent = valueToDisplay;
        }
  
        dropdownList.querySelectorAll('.custom-variant-dropdown__item').forEach(item => item.setAttribute('aria-selected', 'false'));
        if (selectedItemInCustomList) {
          selectedItemInCustomList.setAttribute('aria-selected', 'true');
        }
      };
  
      dropdownButton.addEventListener('click', () => {
        const isExpanded = dropdownButton.getAttribute('aria-expanded') === 'true';
        dropdownButton.setAttribute('aria-expanded', !isExpanded);
        dropdownList.style.display = isExpanded ? 'none' : 'block';
        if (!isExpanded) {
          const currentSelected = dropdownList.querySelector('.custom-variant-dropdown__item[aria-selected="true"]') || dropdownList.querySelector('.custom-variant-dropdown__item:not(.disabled)');
          if (currentSelected) currentSelected.focus();
        }
      });
  
      dropdownList.addEventListener('click', (event) => {
        const listItem = event.target.closest('.custom-variant-dropdown__item');
        if (listItem && !listItem.classList.contains('disabled')) {
          const newValue = listItem.dataset.value;
          const optionIndex = parseInt(listItem.dataset.optionIndex, 10);
  
          // Update custom dropdown UI immediately
          if(selectedValueDisplay) selectedValueDisplay.textContent = newValue;
          dropdownButton.setAttribute('aria-expanded', 'false');
          dropdownList.style.display = 'none';
          dropdownList.querySelectorAll('.custom-variant-dropdown__item').forEach(item => item.setAttribute('aria-selected', 'false'));
          listItem.setAttribute('aria-selected', 'true');
  
          // --- CRUCIAL: Update the hidden Shopify variant picker ---
          const hiddenContainer = getHiddenVariantSelectsContainer();
          if (!hiddenContainer) {
            console.error('Hidden variant-selects container not found when attempting to update.');
            return;
          }
  
          let currentOptionInputGroupIdx = -1;
          let targetOriginalInputContainer = null;
  
          for(let i=0; i < hiddenContainer.children.length; i++) {
              const child = hiddenContainer.children[i];
              if ((child.tagName === 'FIELDSET' && child.classList.contains('product-form__input')) ||
                  (child.tagName === 'DIV' && child.classList.contains('product-form__input--dropdown'))) {
                  currentOptionInputGroupIdx++;
                  if (currentOptionInputGroupIdx === optionIndex) {
                      targetOriginalInputContainer = child;
                      break;
                  }
              }
          }
  
          if (targetOriginalInputContainer) {
            const originalSelect = targetOriginalInputContainer.querySelector('select.select__select');
            const originalRadios = targetOriginalInputContainer.querySelectorAll('input[type="radio"]');
            let changedElement = null;
  
            if (originalSelect) {
              if (originalSelect.value !== newValue) {
                originalSelect.value = newValue;
              }
              changedElement = originalSelect; // Always dispatch on select
            } else if (originalRadios.length > 0) {
              originalRadios.forEach(radio => {
                if (radio.value === newValue) {
                  if (!radio.checked) radio.checked = true;
                  changedElement = radio; // Dispatch on the one that was (or should be) checked
                } else {
                  radio.checked = false;
                }
              });
            }
  
            if (changedElement) {
            //  console.log('Dispatching change event on hidden element:', changedElement, 'with value:', newValue);
              const changeEvent = new Event('change', { bubbles: true, cancelable: true });
              changedElement.dispatchEvent(changeEvent);
            } else {
              console.warn('Could not find the specific hidden select/radio to trigger for optionIndex:', optionIndex, 'newValue:', newValue);
            }
          } else {
            console.error('Could not find corresponding original option input container for index:', optionIndex);
          }
        }
      });
  
      document.addEventListener('click', (event) => {
        if (!container.contains(event.target) && dropdownButton.getAttribute('aria-expanded') === 'true') {
          dropdownButton.setAttribute('aria-expanded', 'false');
          dropdownList.style.display = 'none';
        }
      });
  
      dropdownList.addEventListener('keydown', (event) => {
        const items = Array.from(dropdownList.querySelectorAll('.custom-variant-dropdown__item:not(.disabled)'));
        if (items.length === 0) return;
        const activeElement = document.activeElement;
        let activeIndex = items.findIndex(item => item === activeElement);
  
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (event.key === 'ArrowDown') activeIndex = (activeIndex + 1) % items.length;
          else activeIndex = (activeIndex - 1 + items.length) % items.length;
          items[activeIndex].focus();
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (activeElement.classList.contains('custom-variant-dropdown__item')) {
            activeElement.click();
            dropdownButton.focus();
          }
        } else if (event.key === 'Escape') {
          event.preventDefault();
          dropdownButton.setAttribute('aria-expanded', 'false');
          dropdownList.style.display = 'none';
          dropdownButton.focus();
        } else if (event.key === 'Tab') {
          dropdownButton.setAttribute('aria-expanded', 'false');
          dropdownList.style.display = 'none';
        }
      });
  
      // Initial display update
      updateCustomDropdownDisplay();
  
      // Subscribe to variant changes from product-info.js to re-sync UI
      if (window.Shopify && window.Shopify.pubsub) {
        const sectionId = getSectionId();
        window.Shopify.pubsub.subscribe(PUB_SUB_EVENTS.variantChange, (eventData) => {
          // eventData structure for variantChange can be { data: { sectionId, variant, html } }
          // or sometimes directly contains sectionId.
          const changedSectionId = eventData?.data?.sectionId || eventData?.sectionId;
          if (changedSectionId && changedSectionId.toString() === sectionId) {
            console.log(`Custom dropdown: ${PUB_SUB_EVENTS.variantChange} detected for my section (${sectionId}). Re-syncing display.`);
            updateCustomDropdownDisplay();
          }
        });
      } else {
          console.warn("Shopify pubsub not available for custom dropdown variantChange subscription.");
      }
    }
  
    // Initialize all custom dropdowns on the page
    document.querySelectorAll('.custom-variant-dropdown__container').forEach(container => {
      initializeCustomDropdown(container);
    });
  
    // If you have scenarios where product-info itself is dynamically added after DOMContentLoaded,
    // you might need a MutationObserver to detect new '.custom-variant-dropdown__container' elements.
    // For standard Dawn theme page loads, the above should be sufficient.
  });